// Categories.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IMAGE_BASE_URL } from "../../config";
import { deleteCategory, fetchCategories } from "../../services/tripServices";


export default function Categories() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCategories().then(data => {
            setCategories(data);
            setLoading(false);
        }).catch(err => {
            console.error("Failed to fetch categories:", err);
        });
    }, []);

    const handleDelete = (categoryId) => {
        const conf = window.confirm("Are you sure you want to delete this category?");
        if (!conf) {
            return;
        }
        deleteCategory(categoryId).then(() => {
            setCategories(categories.filter(category => category.id !== categoryId));
            alert("category deleted successfully!");
        }).catch(err => {
            console.error("Failed to delete category:", err);
        });
    };

    return (
        <section className="trips">
            <header className="trips-header">
                <h1>Categories</h1>
                <Link to="/admin/categories/new" className="btn-primary">+ New Category</Link>
            </header>


            <div className="trip-grid">
                {categories && categories.map((cat, i) => (
                    <article className="trip-card" key={i}>
                        <img src={`${IMAGE_BASE_URL}/${cat.thumbnailImage}`} crossOrigin="anonymous" />                      
                        <div className="trip-card-top">
                            <h3>{cat.name}</h3>
                        </div>
                        <p className="meta"> {cat.description}</p>
                        <div className="flex row gap-10">
                            <button><Link to={`/admin/categories/edit/${cat._id}`} className="btn-secondary">Edit</Link></button>
                            <button onClick={() => handleDelete(cat._id)} className="btn-danger">Delete</button>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}